import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

declare global {
  interface Window {
    goatcounter?: {
      count: (opts: { path: string }) => void
    }
  }
}

export function Analytics() {
  const location = useLocation()

  useEffect(() => {
    if (window.goatcounter?.count) {
      window.goatcounter.count({
        path: location.pathname + location.search + location.hash,
      })
    }
  }, [location])

  return null
}
